import { render, staticRenderFns } from "./AddTaskWatcher.vue?vue&type=template&id=669e68fa&scoped=true"
import script from "./AddTaskWatcher.vue?vue&type=script&lang=js"
export * from "./AddTaskWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e68fa",
  null
  
)

export default component.exports